export default __webpack_public_path__ + "static/media/Versions - Comparisons_00.28139916.jpg";